import React, { useState, useEffect } from "react";
import axios from "../../services/api";

const UserLogList = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserLogs();
  }, []);

  const fetchUserLogs = async () => {
    try {
      const response = await axios.get("/api/user-logs");
      setLogs(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user logs:", error);
    }
  };

  return (
    <div className="container">
      <h2>User Activity Logs</h2>
      {loading ? (
        <p>Loading user logs...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Action</th>
              <th>Module</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td>{log.id}</td>
                <td>{log.username}</td>
                <td>{log.action}</td>
                <td>{log.module}</td>
                <td>{new Date(log.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserLogList;
